'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var styled = require('styled-components');
require('../../../themes/alert.js');
require('../../../themes/button.js');
require('../../../themes/checkbox.js');
require('../../../themes/divider.js');
require('../../../themes/dropdown.js');
require('../../../themes/fieldset.js');
require('../../../themes/input.js');
require('../../../themes/list.js');
require('../../../themes/listbox.js');
require('../../../themes/loader.js');
require('../../../themes/option.js');
require('../../../themes/popout.js');
require('../../../themes/switch.js');
var themes = require('../../../themes/themes.js');
require('../../../themes/tooltip.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const BaseTextfieldInner = (props)=>{
    const { children , ...otherProps } = props;
    return /*#__PURE__*/ React__default.default.createElement("div", _extends({}, otherProps, {
        className: classnames__default.default({
            'bf-textfield__inner': true,
            [`${otherProps?.className}`]: !!otherProps?.className
        })
    }), children);
};
const Inner = styled__default.default(BaseTextfieldInner)`
  position: relative;
  flex: 1;
`;
const TextfieldInner = (props)=>{
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(Inner, _extends({}, props)));
};

exports.BaseTextfieldInner = BaseTextfieldInner;
exports.TextfieldInner = TextfieldInner;
//# sourceMappingURL=textfield-inner.js.map
